var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "main" } }, [
    _c("input", {
      ref: "eventoClick",
      staticStyle: { display: "none" },
      attrs: { type: "file", multiple: "false", accept: ".sicarf" },
      on: { change: _vm.handleFileChange }
    }),
    _c(
      "div",
      {
        staticClass: "upload-sicarf",
        class: { "drag-over": _vm.isDragging },
        on: {
          click: function($event) {
            return _vm.callEventClick()
          },
          dragenter: function($event) {
            $event.preventDefault()
            return _vm.onDragEnter($event)
          },
          dragover: function($event) {
            $event.preventDefault()
            return _vm.onDragOver($event)
          },
          dragleave: _vm.onDragLeave,
          drop: function($event) {
            $event.preventDefault()
            return _vm.onDrop($event)
          }
        }
      },
      [_vm._m(0)]
    ),
    _c(
      "ul",
      {
        class: ["el-upload-list", "el-upload-list--text"],
        attrs: { name: "el-list" }
      },
      _vm._l(_vm.fileList, function(file, index) {
        return _c(
          "li",
          {
            key: file.name,
            class: ["el-upload-list__item"],
            attrs: { tabindex: "0" }
          },
          [
            _c("a", { staticClass: "el-upload-list__item-name" }, [
              _c("i", { staticClass: "el-icon-document" }),
              _vm._v(_vm._s(file.name))
            ]),
            _c("i", {
              staticClass: "el-icon-close",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.removeFile()
                }
              }
            })
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-content" }, [
      _c("i", { staticClass: "icon-upload el-icon-upload" }),
      _c("p", { staticClass: "tip-upload" }, [
        _vm._v("Arraste ou clique aqui para enviar o arquivo")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f456058", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f456058","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Importacao/UploadCadastro.vue
// module id = null
// module chunks = 